export enum SensitivityFields {
  NAME = 'name',
  COLOR = 'color',
  SENSITIVITY_ID = 'sensitivity_id',
}
